var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserDetailsNudge = function SvgUserDetailsNudge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19568_56610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 13.3319C3.33594 11.6945 4.66327 10.3672 6.3006 10.3672H9.7046C11.3419 10.3672 12.6693 11.6945 12.6693 13.3319",
    stroke: "#64B1FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0087 3.49588C11.1152 4.60237 11.1152 6.39633 10.0087 7.50282C8.90219 8.60931 7.10823 8.60931 6.00174 7.50282C4.89525 6.39633 4.89525 4.60237 6.00174 3.49588C7.10823 2.38939 8.90219 2.38939 10.0087 3.49588Z",
    stroke: "#64B1FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19568_56610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgUserDetailsNudge as ReactComponent };
export default __webpack_public_path__ + "user-details-nudge.svg";